/*
 * @Author: wzc
 * @Date: 2022-09-15 10:42:36
 * @LastEditors: wzc
 * @LastEditTime: 2022-09-15 19:11:02
 */
export default {
  props: {
    isRefresh: {
      type: Boolean,
      default: false,
    },
    refreshTime: {
      type: Number,
      default: 15 * 1000, //刷新时间 单位毫秒
    },
  },
  data() {
    return {
      setIntervalId: null,
      networkErrpeakVal: 10, //网络报错峰值,大于峰值时，停止更新，且提示：当前网络异常，请检查后重新刷新;
    }
  },
  created() {
    console.debug(`init isRefresh status: ${this.isRefresh}`)
  },
  mounted() {
    // if (this.isRefresh) {
    //   this.refreshCallback()
    // }
  },
  beforeDestroy() {
    console.debug('注销监听事件')
    this.cancelRefreshCallBackHandle()
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`isRefresh status: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle(this.refreshCallback)
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  methods: {
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle(ck) {
      this.setIntervalId = setInterval(() => {
        // this.networkErrorTip()
        ck()
      }, this.refreshTime - 0)
    },
    networkErrorTip(peakVal) {
      //peakVal：峰值
      if (
        window.axiosErrTimeOut &&
        window.axiosErrTimeOut > (peakVal ? peakVal : this.networkErrpeakVal)
      ) {
        console.debug(`无网：${window.axiosErrTimeOut}`)
        this.cancelRefreshCallBackHandle() //网络问题，取消更新机制，提示网络问题并刷新
        this.$message({
          showClose: true,
          duration: 0,
          customClass: 'tipPopClass',
          message: '当前网络异常，请检查后重新刷新',
          type: 'warning',
        })
      }
    },
  },
}
